export default __webpack_public_path__ + "static/media/spinner.169c5527.svg";